import * as z from "zod";

export const RepairFee = z.object({ title: z.string(), fee: z.string() });

export type RepairFee = z.infer<typeof RepairFee>;

export const RepairInvoiceDetails = z.object({
  /** Shopify draft order GID. */
  id: z.string(),
  name: z.string(),
  total: z.number(),
  paid: z.boolean(),
  fees: z.array(RepairFee),
});

export const getRepairInvoiceDetails = {
  name: "getRepairInvoiceDetails" as const,
  input: z.object({ returnId: z.string() }),
  /** Null when the return has no repair invoice yet. */
  output: RepairInvoiceDetails.nullable(),
};
